import axios from 'axios';

let lang = 'ar'; 
if (typeof window !== 'undefined') {
  const storedLang = localStorage.getItem('language');
  lang = storedLang == 'en' ? 'en' : 'ar';
}
const currency = localStorage.getItem('currency')

const baseURL = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': lang || 'ar',
    'X-Currency': currency || 'EGP',
    'x-api-key': 'base64:NnQp8jV6bp5tErWgwYoKjSY0YODOO4maVCrkqWCFgT8='
  },
});

baseURL.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // إطلاق الحدث ومسح بيانات الجلسة
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      window.dispatchEvent(new CustomEvent('unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default baseURL;
